import React from 'react';
import {Grid} from '@material-ui/core';
import {SwitchCustom} from '../../Core/UI';
import {Prequal} from '../../Core/mobx/ParameterStore/Prequal';
import {Parameter} from '../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import {Approval} from '../../Core/mobx/ParameterStore/Approval';

type BehaviorProps = {
    parameters: Prequal | Approval;
    valueChanged: (p?: Parameter & {name?: string}, value?: any) => void;
    preapproval?: boolean;
};

const Behavior = observer(({parameters, valueChanged, preapproval}: BehaviorProps) => {
    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    return (
        <>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        label: 'Drug or Alcohol Dependence / Withdrawal',
                        ...parameters.DrugorAlcoholDependenceWithdrawal,
                        name: 'DrugorAlcoholDependenceWithdrawal',
                    }}
                    required={preapproval ? required('') : ''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        label: 'DUI',
                        ...parameters.DUI,
                        name: 'DUI',
                    }}
                    required={preapproval ? required('') : ''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        label: 'License',
                        ...parameters.License,
                        name: 'License',
                    }}
                    required={preapproval ? required('') : ''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        label: 'Moving violations',
                        ...parameters.Movingviolations,
                        name: 'Movingviolations',
                    }}
                    required={preapproval ? required('') : ''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        label: 'Criminal offense',
                        ...parameters.Criminaloffense,
                        name: 'Criminaloffense',
                    }}
                    required={preapproval ? required('') : ''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        label: 'Bankruptcy',
                        ...parameters.Bankruptcy,
                        name: 'Bankruptcy',
                    }}
                    required={preapproval ? required('') : ''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={12}>
                <div style={{fontSize: 20, color: '#5D6CC1', fontWeight: 'bold', marginTop: '1em'}}>Anytime</div>
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        label: 'HIV or AIDS?',
                        ...parameters.HIV,
                        name: 'HIV',
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        label: 'Extreme Sports',
                        ...parameters.extremeSports,
                        name: 'extremeSports',
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        label: 'Daily Assistance Needed',
                        ...parameters.livingAssistance,
                        name: 'livingAssistance',
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
        </>
    );
});

export default Behavior;
